// Spanish language pack
// Note: All keys are in Simplified Chinese, values are in Spanish
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Activos de la Plataforma',
    '质押金额': 'Monto de Hashrate',
    '算力周期': 'Período de Computación',
    '天': 'Días',
    '算力类型': 'Tipo de Poder Computacional',
    '基础算力': 'Computing Básico',
    '高级算力': 'Computing Avanzado',
    '超级算力': 'Super Computing',
    '企业算力': 'Computing Empresarial',
    '高性能': 'Alto Rendimiento',
    '标准': 'Estándar',
    '经济型': 'Económico',
    '申请算力': 'Solicitar Computing',
    '申请解押': 'Rescate de Hashrate',
    '可申请次数': 'Aplicaciones Disponibles',
    '剩余次数': 'Veces Restantes',
    '短算力类型': 'Tipo',
    '短算力周期': 'Periodo',
    '短预计日收益': 'Diario',
    '短剩余次数': 'Restan',
    '短解押记录': 'Rescate',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Pend.',
    '短成功': 'Exito',
    '短失败': 'Fallo',
    '短完成': 'Fin.',
    '超级算力申请': 'Leasing de Hashrate',

    '步骤提示租赁': 'Paso 1 Selecciona un plan de hashrate · Paso 2 Toca "Leasing de Hashrate"',
    '请选择算力方案': 'Selecciona un plan de hashrate',
    '请先选择算力方案': 'Selecciona primero un plan de hashrate y luego toca leasing',    '算力收益等级': 'Niveles de Rendimiento Computing',
    '查看算力收益等级': 'Ver Niveles de Rendimiento',
    '暂无高级算力等级数据': 'No hay datos de niveles de computing avanzado disponibles',
    '暂无超级算力等级数据': 'No hay datos de niveles de super computing disponibles',

    // Página de Detalles de Aplicación Computing
    '算力详情': 'Detalles de Computing',
    '基本信息': 'Información Básica',
    '原押金额': 'Cantidad de Apuesta Original',
    '每日收益记录': 'Registros de Ganancias Diarias',
    '暂无数据': 'No Hay Datos Disponibles',

    // Computing details
    '算力类型标签': 'Tipo:',
    '算力周期标签': 'Período:',
    '算力类型：': 'Tipo:',
    '算力周期：': 'Período:',
    '预计收益：': 'Ganancias:',
    '质押要求：': 'Apuesta:',
    '开始时间：': 'Inicio:',
    '结束时间：': 'Fin:',
    '立即申请': 'Aplicar',

    // Status and prompts
    '申请中...': 'Cargando...',
    '申请中': 'Cargando...',
    '申请成功': 'Exitoso',
    '申请失败': 'Fallido',
    '申请失败，请重试': 'Aplicación falló, inténtelo de nuevo',
    '余额不足': 'Saldo Insuficiente',
    '请先连接钱包': 'Conectar Billetera',
    '算力申请成功！': '¡Computing exitoso!',
    '算力申请失败，请重试': 'Computing fallido, reintentar',
    '申请失败，请先解押已完成的算力订单': 'Solicitud fallida, por favor desbloquea primero la orden de poder computacional completada',
    
    // Confirmation dialog
    '确认申请': 'Confirmar Aplicación',
    '取消': 'Cancelar',
    '确认': 'Confirmar',
    '您确定要申请此算力吗': '¿Solicitar este computing?',
    '您确定要申请此算力吗？': '¿Solicitar este computing?',
    '申请后将扣除相应的质押金额': 'Se deducirá la cantidad',
    
    // Computing status
    '运行中': 'En Ejecución',
    '已完成': 'Completado',
    '待开始': 'Pendiente',
    '已取消': 'Cancelado',
    
    // Earnings related
    'USDC': 'USDC',
    '预计日收益': 'Ganancias Diarias Esperadas',
    '总预计收益': 'Ganancias Totales Esperadas',
    '当前收益': 'Ganancias Actuales',
    
    // Records and status
    '解押申请记录': 'Registros de Rescate',
    '超级算力申请记录': 'Registros de Solicitud de Super Poder Computacional',
    '全部': 'Todos',
    '待审核': 'Pendiente',
    '成功': 'Éxito',
    '失败': 'Falló',
    '正在加载记录': 'Cargando registros...',
    '暂无记录': 'Sin registros',
    '解押金额': 'Monto de Rescate',
    '申请天数': 'Días de Solicitud',
    '金额': 'Cantidad',

    // Modal related
    '选择周期': 'Período Seleccionado',
    '收益率': 'Tasa de Rendimiento',
    '申请金额': 'Cantidad de Solicitud',
    '请输入申请金额': 'Por favor, ingrese la cantidad de solicitud',
    '最大可申请金额': 'Cantidad máxima aplicable',
    '投入限额': 'Límite de Inversión',
    '最低投入': 'Inversión Mínima',
    '最大投入': 'Inversión Máxima',
    '短投入限额': 'Límite',
    '请输入有效的申请金额': 'Por favor, ingrese una cantidad de solicitud válida',
    '申请金额不能低于最低投入': 'La cantidad de solicitud no puede ser inferior a la inversión mínima',
    '申请金额不能高于最大投入': 'La cantidad de solicitud no puede superar la inversión máxima',

    // Error messages
    '网络错误，请稍后重试': 'Error de red, inténtelo de nuevo más tarde',
    '参数错误': 'Error de parámetro',
    '服务器错误': 'Error del servidor',
    '未知错误': 'Error desconocido',
    '请输入有效金额': 'Por favor, ingrese una cantidad válida',
    '请输入大于0的解押金额': 'Por favor, ingrese una cantidad de liberación mayor que 0',
    '申请提交成功': '¡Solicitud enviada exitosamente!',
    '您的解押申请已提交，请等待审核': 'Su solicitud de liberación ha sido enviada, espere la revisión',
    '申请提交失败': 'Fallo en el envío de la solicitud',
    '请稍后重试': 'Inténtelo de nuevo más tarde',
    '您的账户余额不足，无法申请算力': 'Su saldo de cuenta es insuficiente para solicitar poder computacional',
    '您的算力申请已提交，请等待审核': 'Su solicitud de poder computacional ha sido enviada, espere la revisión',
    '登录已过期': 'Sesión expirada',
    '请重新连接钱包': 'Por favor, reconecte la billetera',
    '加载失败': 'Fallo en la carga',
    '无法获取解押申请记录': 'No se pueden obtener registros de solicitud de liberación',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Tiene una solicitud pendiente de revisión, espere a que se complete la revisión antes de enviar una nueva solicitud',
    '您还有未解押的算力订单，无法申请新的算力': 'Tiene una orden de poder computacional sin liberar, no puede solicitar nuevo poder computacional',
    '申请次数已用完，最大申请次数': 'Se ha alcanzado el límite de solicitudes, máximo de solicitudes',
    '没有可解押的金额': 'No hay cantidad disponible para desbloquear',
    '您已有待处理的解押申请，请等待审核': 'Ya tiene una solicitud de desbloqueo pendiente, espere la revisión',

    '我的算力订单': 'Mis Órdenes de Hashrate',
    '总质押': 'Total en Staking',
    '总收益': 'Ganancia Total',
    '进行中': 'Activo',
    '剩余天数': 'Días Restantes',
    '暂无算力订单': 'Sin órdenes de hashrate',

    // Ventanas emergentes relacionadas con conexión de billetera
    '钱包未连接': 'Billetera no conectada',
    '钱包信息错误': 'Error de información de billetera',
    '钱包地址无效': 'Dirección de billetera inválida',
    '授权已失效': 'Autorización expirada',
    '授权检查失败': 'Verificación de autorización fallida',
    '请重新授权USDC后再进行投资': 'Por favor reautorizar USDC antes de invertir',
    '请稍后重试或重新连接钱包': 'Inténtelo más tarde o reconecte la billetera',
    '断开连接': 'Desconectar',
    '质押金额不足': 'Cantidad apostada insuficiente',
    '解押金额不能超过当前质押金额': 'La cantidad de liberación no puede exceder la cantidad apostada actual',
    '需要连接钱包才能申请算力': 'Necesita conectar billetera para solicitar poder computacional',
    '需要连接钱包才能申请解押': 'Necesita conectar billetera para solicitar liberación',

    // Mapeo de texto de estado
    '状态待审核': 'Pendiente',
    '状态成功': 'Exitoso',
    '状态失败': 'Fallido',
    '状态进行中': 'En Progreso',
    '状态已完成': 'Completado',
    '状态已取消': 'Cancelado',
    '状态未知': 'Desconocido',

    // Relacionado con dirección de billetera
    '未连接钱包': 'Billetera no conectada',
    '地址格式错误': 'Formato de dirección inválido',

    // Servicio al cliente
    '客服功能开发中，敬请期待': '¡El servicio al cliente está en desarrollo, manténganse atentos!',

    // Relacionado con configuraciones de poder computacional
    '设置错误': 'Error de configuración',
    '未找到对应的算力设置': 'Configuraciones de poder computacional no encontradas',
    '无法获取算力设置': 'No se pueden obtener las configuraciones de poder computacional',

    // Relacionado con liberación (nuevo)
    '解押审核中': 'Liberación en Revisión',
    '已解押': 'Liberado',
    '确认解押': 'Confirmar Liberación',
    '处理中': 'Procesando...',
    '解押申请已提交': 'Solicitud de Liberación Enviada',
    '请等待审核处理': 'Por favor espere la revisión',
    '解押申请失败': 'Fallo en la Solicitud de Liberación',
    '当前状态不允许解押': 'El estado actual no permite la liberación',

    // Relacionado con detalles de garantía (nuevo)
    '质押明细': 'Detalles de Hashrate',
    '后值': 'Valor Posterior',
    '管理员操作': 'Operación del Sistema',
    '暂无质押记录': 'No hay registros de hashrate',
    '正在加载质押记录': 'Cargando registros de hashrate...',
    '获取质押记录失败': 'No se pudieron obtener los registros de hashrate',
    '收益': 'Ganancias',
    '质押': 'Hashrate',
    '解押': 'Rescate',
    '充值': 'Depósito',
    '提现': 'Retiro',
    '奖励': 'Recompensa',
    '推荐奖励': 'Recompensa de Referencia',
    '系统调整': 'Ajuste del Sistema',
    '算力收益': 'Ganancias de Computación',
    '机器人收益': 'Ganancias de Bot',

    // Mensajes de carga y error (nuevo)
    '无法获取申请详情': 'No se pueden obtener los detalles de la solicitud',
    '请检查网络连接后重试': 'Por favor verifique la conexión de red e intente nuevamente',
    '未找到可解押的算力申请': 'No se encontraron solicitudes de poder computacional liberables',

    // Relacionado con estado (nuevo)

    // Relacionado con página de detalles (nuevo)
    '算力申请详情': 'Detalles de Solicitud de Poder Computacional',
    '算力申请记录': 'Registros de Solicitudes de Poder Computacional',
    '正在加载详情': 'Cargando detalles...',
    '申请周期': 'Período de Solicitud',
    '申请时间': 'Tiempo de Solicitud',
    '累计收益': 'Ganancias Totales',
    '暂无收益记录': 'Sin registros de ganancias',
    '加载失败请重试': 'Fallo de carga, por favor reintente',
    '重新加载': 'Recargar',
    '包含累计收益': 'incluyendo ganancias totales',
    '解押后资金将退回到平台资产中不再产生收益': 'Después de la liberación, los fondos serán devueltos a los activos de la plataforma y ya no generarán ganancias.',
    '申请赎回': 'Canjear Hashrate',
    '赎回金额': 'Monto de Canje',
    '赎回审核中': 'Canje en Revisión',
    '未到期不可赎回': 'No se puede canjear antes del vencimiento',
    '暂不可赎回': 'Aún No Canjeable',
    '当前算力未到期': 'El hashrate actual no ha vencido, el canje estará disponible después del vencimiento',
    '需要连接钱包才能申请赎回': 'Necesita conectar la billetera para solicitar el canje',
    '您的赎回申请已提交，请等待审核': 'Su solicitud de canje ha sido enviada, por favor espere la revisión',
    '确认赎回': 'Confirmar canje',
    '已赎回': 'Canjeado',
    '您已有待处理的赎回申请，请等待审核': 'Ya tiene una solicitud de canje pendiente, espere la revisión',
    '当前状态不允许赎回': 'El estado actual no permite el canje',
    '没有可赎回的金额': 'No hay monto disponible para canje'
  },

  // ==================== Página de Activos - Assets.vue ====================
  assets: {
    // Activos totales
    '总资产': 'Activos Totales',
    '复制成功': 'Copiado correctamente',

    // Resumen de ingresos
    '总收入': 'Ingresos Totales',
    '今日收入': 'Ingresos de Hoy',
    '体验金': 'Saldo de Demostración',
    '空投奖励': 'Recompensas Airdrop',

    // Botones de acción
    '充值': 'Depósito',
    '快速充值说明': 'Deposita USDC rapido',
    '提现': 'Retiro',
    '邀请': 'Invitar',
    '白皮书': 'Libro Blanco',
    '幸运轮': 'Rueda de la Suerte',
    '站内信': 'Mensajes',
    '信用分': 'Puntuación de Crédito',
    '快捷邀请': 'Invitar',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Suerte',
    '快捷信用分': 'Crédito',

    // Nivel VIP
    'VIP等级': 'Nivel VIP',
    '暂无VIP等级数据': 'No hay datos de nivel VIP disponibles',

    // Mi cuenta
    '我的账户': 'Mi Cuenta',
    '申请备用金': 'Solicitar Fondo de Reserva',
    '设置资金密码': 'Establecer Contraseña de Fondos',
    '选择语言': 'Seleccionar Idioma',

    // Mensajes de log de consola
    '钱包未连接，触发钱包连接': 'Billetera no conectada, activando conexión de billetera',
    '钱包地址无效，重新连接': 'Dirección de billetera inválida, reconectando',
    '钱包已连接，直接跳转到充值页面': 'Billetera conectada, redirigiendo a página de depósito',
    '检查授权状态失败': 'Fallo al verificar estado de autorización',
    '白皮书功能': 'Función libro blanco',
    '检查资金密码状态失败': 'Fallo al verificar estado de contraseña de fondos',

    // Logs relacionados con API
    'Token不存在，显示默认余额': 'Token no existe, mostrando saldo predeterminado',
    '调用API获取用户余额数据': 'Llamando API para obtener datos de saldo del usuario...',
    '体验金加载成功': 'Saldo de demostración cargado exitosamente',
    '总资产计算完成': 'Cálculo de activos totales completado',
    '余额': 'Saldo',
    '质押金额': 'Monto de Hashrate',
    'API返回失败': 'API devolvió fallo',
    '加载用户余额失败': 'Fallo al cargar saldo del usuario',
    'Token不存在，显示默认收益': 'Token no existe, mostrando ganancias predeterminadas',
    '调用API获取用户收益数据...': 'Llamando API para obtener datos de ganancias del usuario...',
    '收益数据加载成功': 'Datos de ganancias cargados exitosamente',
    '收益API返回失败': 'API de ganancias devolvió fallo',
    '加载用户收益失败': 'Fallo al cargar ganancias del usuario',
    '使用默认收益数据': 'Usando datos de ganancias predeterminados',
    '信用分加载成功': 'Puntuación de crédito cargada exitosamente'
  },

  // ==================== Página de Recarga - Recharge.vue ====================
  recharge: {
    // Título de página y navegación
    '充值': 'Recargar',
    '返回': 'Volver',
    '充值记录': 'Historial de Recarga',

    // Títulos de pasos
    '选择金额': 'Seleccionar Cantidad',
    '确认订单': 'Confirmar Pedido',
    '完成转账': 'Completar Transferencia',

    // Entrada de cantidad
    '请输入充值金额': 'Por favor ingrese la cantidad de recarga',
    '自定义': 'Personalizado',
    '最小充值金额': 'Cantidad mínima de recarga',
    '最小充值金额提示': 'Minimo 500 USDC',
    '最大充值金额': 'Cantidad máxima de recarga',
    '下一步': 'Siguiente',
    '上一步': 'Anterior',
    '开通自动转入': 'Habilitar Transferencia Automática',

    // Información del pedido
    '订单信息': 'Información del Pedido',
    '订单号': 'Número de Pedido',
    '充值金额': 'Cantidad de Recarga',
    '网络': 'Red',
    '代币': 'Token',
    '收款地址': 'Dirección de Recepción',
    '创建订单': 'Crear Pedido',
    '创建中': 'Creando...',

    // Conexión de billetera
    '请先连接钱包': 'Conecta la billetera primero',
    '未检测到钱包地址，请先连接钱包': 'Dirección de billetera no detectada, conecta la billetera primero',

    // Saldo
    'USDC余额不足': 'Saldo USDC insuficiente! Saldo actual',
    '转账超时，请检查钱包或重试': 'Timeout de transferencia, verifica la billetera o reintenta',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Transferencia exitosa pero no se recibió hash de transacción, proporciona el hash de transacción manualmente',
    '请先连接MetaMask钱包': 'Conecta la billetera MetaMask primero',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'La transferencia puede haber sido exitosa pero no se puede obtener el hash de transacción, verifica la billetera manualmente',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Hash de transacción inválido, copia el hash correcto del historial de la billetera más tarde',
    '钱包地址不存在': 'La dirección de la billetera no existe',
    '交易失败': 'Transacción falló',
    '当前网络': 'Red actual',
    '请切换到以太坊主网或测试网': 'Cambia a la red principal de Ethereum o testnet',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Por favor, haz clic en la configuración de red en la esquina superior derecha de la página, selecciona Ethereum y luego recarga nuevamente.',
    '需要': 'Requerido',
    '更新订单失败': 'Error al actualizar pedido',

    // Pasos de transferencia
    '请使用钱包转账': 'Por favor use la billetera para transferir',
    '转账地址': 'Dirección de Transferencia',
    '转账金额': 'Cantidad de Transferencia',
    '合约地址': 'Dirección del Contrato',
    '复制地址': 'Copiar Dirección',
    '复制金额': 'Copiar Cantidad',
    '开始转账': 'Iniciar Transferencia',
    '重新转账': 'Reintentar Transferencia',
    '查看详情': 'Ver Detalles',

    // Información de estado
    '等待转账': 'Esperando transferencia',
    '转账中': 'Transfiriendo',
    '确认中': 'Confirmando',
    '转账成功': 'Transferencia exitosa',
    '转账失败': 'Transferencia fallida',
    '交易哈希': 'Hash de Transacción',
    '在区块链浏览器中查看': 'Ver en explorador de blockchain',

    // Consejos
    '请确保转账金额准确': 'Por favor asegúrese de que la cantidad de transferencia sea exacta',
    '请确保使用正确的网络': 'Por favor asegúrese de usar la red correcta',
    '转账完成后系统会自动确认': 'El sistema confirmará automáticamente después de completar la transferencia',
    '地址已复制': 'Dirección copiada',
    '金额已复制': 'Cantidad copiada',
    '复制失败': 'Copia fallida',

    // Mensajes de error
    '金额不能为空': 'La cantidad no puede estar vacía',
    '金额必须大于': 'La cantidad debe ser mayor que',
    '金额不能超过': 'La cantidad no puede exceder',
    '创建订单失败': 'Error al crear pedido',
    '转账失败，请重试': 'Transferencia fallida, por favor reintente',
    '网络错误，请检查连接': 'Error de red, por favor verifique la conexión',

    // MetaMask相关
    '请安装MetaMask钱包': 'Por favor instale la billetera MetaMask',
    '网络检查通过': 'Verificación de red aprobada',
    'USDC余额不足！当前余额': 'Saldo USDC insuficiente! Saldo actual: {balance} USDC, requerido: {amount} USDC',
    '余额检查通过': '✅ Verificación de saldo aprobada',
    '余额检查失败': 'Verificación de saldo falló',
    '开始执行转账': '🚀 Iniciando ejecución de transferencia...',
    '请在MetaMask中确认交易': '⏳ Por favor confirme la transacción en MetaMask',
    '最终交易哈希': '✅ Hash de transacción final',
    '交易哈希已保存到数据库': '✅ Hash de transacción guardado en la base de datos',
    '保存哈希失败': '❌ Error al guardar hash',
    '转账发送失败': '❌ Error en el envío de transferencia',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Timeout de envío de transacción, verifique los registros de transacción de la billetera o reintente más tarde',
    'Gas估算失败': 'Estimación de Gas falló',
    '交易哈希更新成功': '✅ Hash de transacción actualizado exitosamente',
    '更新订单交易哈希失败': '❌ Error al actualizar hash de transacción del pedido',
    '启动交易监控，订单号': '🔄 Iniciando monitoreo de transacción, número de pedido',
    '检查交易状态': '🔍 Verificando estado de transacción...',
    '订单状态响应': '📊 Respuesta del estado del pedido',
    '订单详情': '📋 Detalles del pedido',
    '交易成功': '✅ ¡Transacción exitosa!',
    '交易还在确认中，状态': '⏳ Transacción aún en confirmación, estado',
    'API响应失败': '❌ Respuesta de API falló',
    '检查交易状态失败': 'Verificación del estado de transacción falló',
    '转账状态已重置': '🔄 Estado de transferencia restablecido',

    // Servicio al cliente
    '客服功能开发中，敬请期待': '¡Función de servicio al cliente en desarrollo, mantente atento!',

    // Niveles de tasa de potencia de cálculo
    '查看算力收益等级': 'Ver niveles de tasa de cálculo',
    '算力收益等级': 'Niveles de tasa de potencia de cálculo',
    '暂无算力收益等级数据': 'No hay datos de niveles de tasa de cálculo disponibles',
    '获取算力收益等级失败': 'Error al obtener los niveles de tasa de cálculo',
    '日收益率': 'Tasa diaria'
  },

  // ==================== Página de Historial de Recarga - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Historial de Recarga',
    '全部': 'Todos',
    '待支付': 'Pendiente de Pago',
    '待审核': 'Pendiente de Revisión',
    '确认中': 'Confirmando',
    '成功': 'Éxito',
    '失败': 'Fallido',
    '已完成': 'Completado',
    '已取消': 'Cancelado',
    '暂无记录': 'Sin registros',
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',
    '没有更多数据': 'No hay más datos',
    '暂无充值记录': 'Sin registros de recarga',
    '立即充值': 'Recargar Ahora',
    '充值': 'Recarga',
    '订单号': 'Número de Pedido',
    '筛选': 'Filtro',
    '记录': 'Registros',
    '总充值': 'Recarga Total',
    '刚刚': 'Ahora mismo',
    '分钟前': ' minutos',
    '小时前': ' horas'
  },

  // ==================== Página de Detalles de Recarga - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Detalles de Recarga'
  ,

    // 新增翻译键
    '加载中': 'Cargando',
    '订单不存在或已删除': 'El pedido no existe o ha sido eliminado',
    '返回': 'Volver',
    '订单信息': 'Información del pedido',
    '订单号': 'Número de pedido',
    '充值网络': 'Red de recarga',
    '支付时间': 'Hora de pago',
    '确认时间': 'Hora de confirmación',
    '转账信息': 'Información de transferencia',
    '充值地址': 'Dirección de recarga',
    '复制': 'Copiar',
    '交易哈希': 'Hash de transacción',
    '确认进度': 'Progreso de confirmación',
    '确认': 'Confirmación',
    '查看区块浏览器': 'Ver explorador de bloques',
    '取消订单': 'Cancelar pedido'
  },

  // ==================== Página de Retiro - Withdrawal.vue ====================
  withdrawal: {
    // Título de página y navegación
    '提现': 'Retiro',
    '返回': 'Volver',
    '提现记录': 'Historial de Retiros',

    // Visualización de saldo
    '我的提现账户余额': 'Saldo de Mi Cuenta de Retiro',
    '可提现余额': 'Saldo Disponible',
    '当前可提取余额': 'Saldo Disponible Actual',
    '信用分': 'Crédito',

    // Campos de formulario
    '提现金额': 'Cantidad de Retiro',
    '请输入提现金额': 'Por favor ingrese la cantidad de retiro',
    '请输入自定义提款金额': 'Por favor ingrese una cantidad personalizada',
    '最大限度': 'Máx',
    '提现地址': 'Dirección de Retiro',
    '请输入提现地址': 'Por favor ingrese la dirección de retiro',
    '提现密码': 'Contraseña de Retiro',
    '请输入提现密码': 'Por favor ingrese la contraseña de retiro',
    '资金密码': 'Contraseña de Fondos',
    '请输入资金密码': 'Por favor ingrese la contraseña de fondos',
    '显示密码': 'Mostrar Contraseña',
    '隐藏密码': 'Ocultar Contraseña',

    // Reglas de retiro
    '提款规则': 'Reglas de Retiro',
    '提现规则': 'Reglas de Retiro',
    '手续费': 'Comisión',
    '单笔范围': 'Rango por operación',
    '提现手续费': 'Tarifa de Retiro',
    '提现金额范围': 'Rango de Cantidad de Retiro',
    '资金将在1-24小时内到账': 'Los fondos llegarán en 1-24 horas',
    '手续费率': 'Tasa de Comisión',
    '最小提现金额': 'Retiro Mínimo',
    '最大提现金额': 'Retiro Máximo',
    '预计到账时间': 'Tiempo de Llegada Esperado',
    '工作日内处理': 'Procesado en días laborables',

    // Botones y acciones
    '确认提款': 'Confirmar Retiro',
    '处理中': 'Procesando',
    '提交申请': 'Enviar Solicitud',
    '设置资金密码': 'Establecer Contraseña de Fondos',
    '忘记密码？': '¿Olvidó la Contraseña?',
    '取消': 'Cancelar',
    '去设置': 'Ir a Configuración',

    // Avisos modales
    '需要设置资金密码': 'Necesita Establecer Contraseña de Fondos',
    '为了您的资金安全，请先设置资金密码': 'Para la seguridad de sus fondos, por favor establezca primero la contraseña de fondos',

    // Mensajes de éxito
    '申请提交成功': 'Solicitud Enviada Exitosamente',
    '您的提现申请已提交，请等待审核': 'Su solicitud de retiro ha sido enviada, por favor espere la revisión',
    '提现申请已提交': 'Solicitud de retiro enviada',
    '请等待审核': 'Por favor espere la revisión',

    // Mensajes de error
    '申请提交失败': 'Fallo en el Envío de Solicitud',
    '提现申请失败': 'Fallo en la solicitud de retiro',
    '请稍后重试': 'Por favor reintente más tarde',
    '余额不足': 'Saldo Insuficiente',
    '金额格式错误': 'Formato de cantidad inválido',
    '地址格式错误': 'Formato de dirección inválido',
    '资金密码错误': 'Contraseña de fondos incorrecta',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Tiene una solicitud de retiro pendiente, espere a que se procese antes de enviar una nueva',
    '信用分不足': 'Puntuación de Crédito Insuficiente',
    '信用分不足无法提款': 'Puntuación de crédito insuficiente, no se puede retirar',
    '您有待还款订单，请还款后申请提现': '¡Tiene pedidos de préstamo pendientes. Por favor, pague antes de solicitar un retiro!',

    // Mensajes del sistema y logs
    '用户提现申请': 'Solicitud de retiro de usuario',
    '加载用户数据失败': 'Fallo al cargar datos de usuario',
    '检查资金密码状态失败': 'Fallo al verificar el estado de la contraseña de fondos'
  },



  // ==================== Modal de Invitación - InviteModal.vue ====================
  invite: {
    '邀请好友一起赚币': 'Invitar amigos a ganar juntos',
    '复制邀请码': 'Copiar código de invitación',
    '朋友扫二维码注册加入': 'Los amigos escanean el código QR para registrarse',
    '邀请链接': 'Enlace de invitación',
    '加载邀请数据失败': 'Error al cargar datos de invitación',
    '加载失败': 'Carga fallida',
    '获取邀请信息失败，请稍后重试': 'Error al obtener info de invitación, inténtelo más tarde',
    '生成二维码失败': 'Error al generar código QR',
    '邀请码已复制': 'Código de invitación copiado',
    '邀请链接已复制': 'Enlace de invitación copiado',
    '复制失败': 'Fallo al copiar',
    '请手动复制': 'Por favor copie manualmente'
  },

  // ==================== Página Rueda de la Fortuna - LuckyWheel.vue ====================
  luckyWheel: {
    '幸运轮': 'Rueda de la Fortuna',
    '页面副标题': 'Sorteo en cuadrícula · carrera de luces',
    '剩余': 'Restantes',
    '次': 'veces',
    '奖金': 'Premio',
    '抽奖': 'Sorteo',
    '奖品': 'Premio',
    '暂无中奖记录': 'Sin registros de premio',
    '总抽奖次数': 'Sorteos Totales',
    '抽奖次数不足': 'Sorteos insuficientes',
    '提示': 'Aviso',
    '抽奖失败': 'Sorteo falló',
    '网络错误': 'Error de red',
    '网络错误，请重试': 'Error de red, inténtalo de nuevo',
    '中奖时间': 'Hora de Premio',
    '中奖金额': 'Cantidad Ganada',
    '状态': 'Estado',
    '暂无数据': 'Sin datos',
    '待发放': 'Pendiente',
    '已发放': 'Distribuido',
    '发放失败': 'Fallido',
    '恭喜中奖': '¡Felicidades!',
    '确定': 'OK'
  },

  // ==================== Página Solicitar Fondos - ApplyFunds.vue ====================
  applyFunds: {
    '申请备用金': 'Solicitar Fondos',
    '经平台审核，您可向平台申请一笔借款': 'Después de la revisión de la plataforma, puede solicitar un préstamo',
    '借贷产品': 'Producto de Préstamo',
    '请选择产品': 'Por favor seleccione producto',
    '借款金额': 'Cantidad del Préstamo',
    '输入借款金额': 'Ingrese cantidad del préstamo',
    '还款周期': 'Período de Reembolso',
    '请输入还款周期': 'Ingrese período de reembolso',
    '天': 'días',
    '日利率': 'Tasa Diaria',
    '利息': 'Interés',
    '还款方式': 'Método de Reembolso',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Servicio gratuito proporcionado por HamiltonLane, reembolse con fondos externos',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Servicio gratuito proporcionado por HamiltonLane, reembolse con fondos externos',
    '放款机构': 'Institución Prestamista',
    '借款规则': 'Reglas de Préstamo',
    '下一步': 'Siguiente',
    '姓名': 'Nombre',
    '手机号': 'Teléfono',
    '证件上传': 'Subida de Documentos',
    '身份证正面': 'Frente del DNI',
    '身份证反面': 'Reverso del DNI',
    '点击上传': 'Hacer Clic para Subir',
    '重新上传': 'Subir de Nuevo',
    '上传成功': 'Subida Exitosa',
    '上传失败': 'Fallo en la Subida',
    '请上传身份证正面': 'Por favor suba el frente del DNI',
    '请上传身份证反面': 'Por favor suba el reverso del DNI',
    '请输入': 'Por favor ingrese',
    '提交中': 'Enviando...',
    '确定': 'Confirmar',
    '请选择图片文件': 'Seleccione un archivo de imagen',
    '文件大小不能超过10MB': 'El tamano del archivo no puede superar 10MB',
    '恭喜您申请成功': 'Felicidades por su solicitud exitosa',
    '您的借款已申请成功，待平台审核成功放款': 'Su solicitud de préstamo fue exitosa, esperando aprobación de la plataforma',
    '选择借贷产品': 'Seleccionar Producto de Préstamo',

    // Mensajes de error
    '申请失败': 'Solicitud Falló',
    '申请失败，请重试': 'Solicitud falló, inténtelo de nuevo',

    // Traducciones de nombres de productos
    '产品名称': {
      '快速借贷': 'Préstamo Rápido',
      '标准借贷': 'Préstamo Estándar',
      '长期借贷': 'Préstamo a Largo Plazo',
      '小额借贷': 'Microcrédito',
      '大额借贷': 'Préstamo de Gran Cantidad',
      '短期借贷产品': 'Producto de Préstamo a Corto Plazo'
    },

    // Traducciones de descripciones de productos
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Adecuado para rotación de capital a corto plazo, tasas de interés preferenciales, aprobación rápida'
    },

    // Traducciones de mensajes de API
    'API消息': {
      '获取借贷产品成功': 'Productos de préstamo recuperados exitosamente'
    }
  },

  // ==================== Página Registros de Préstamos - LoanRecords.vue ====================
  loanRecords: {
    '借款记录': 'Registros de Préstamos',
    '借贷中心': 'Centro de Prestamos',
    '总记录': 'Total de Registros',
    '总借款': 'Total Prestado',
    '进行中': 'En Progreso',
    '全部': 'Todos',
    '加载中': 'Cargando',
    '没有更多数据了': 'No más datos',
    '借款': 'Préstamo',
    '借款金额': 'Cantidad del Préstamo',
    '还款周期': 'Período de Reembolso',
    '天': 'días',
    '日利率': 'Tasa Diaria',
    '利息': 'Interés',
    '还款方式': 'Método de Reembolso',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Servicio gratuito proporcionado por HamiltonLane, reembolse con fondos externos',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Servicio gratuito proporcionado por HamiltonLane, reembolse con fondos externos',
    '放款机构': 'Institución Prestamista',
    '待审核': 'Pendiente',
    '已通过': 'Aprobado',
    '审核成功': 'Aprobado',
    '已驳回': 'Rechazado',
    '审核失败': 'Rechazado',
    '已还款': 'Reembolsado',
    '已逾期': 'Vencido',
    '逾期': 'Vencido',
    '未知状态': 'Estado Desconocido'
  },

  // ==================== Página Establecer Contraseña de Fondos - SetFundPassword.vue ====================
  setFundPassword: {
    '设置资金密码': 'Establecer Contraseña de Fondos',
    '安全中心': 'Centro de Seguridad',
    '密码长度至少6位': 'La contraseña debe tener al menos 6 caracteres',
    '密码长度不超过20位': 'La contraseña no debe exceder 20 caracteres',
    '确认密码': 'Confirmar Contraseña',
    '两次输入的密码一致': 'Las contraseñas coinciden',
    '设置中': 'Configurando...',
    '确定': 'Confirmar',

    // Mensajes de respuesta API
    '参数验证失败': 'Falló la validación de parámetros',
    '您已设置过资金密码，如需修改请联系客服': 'Ya has establecido una contraseña de fondos. Contacta al servicio al cliente para modificarla',
    '资金密码设置成功': 'Contraseña de fondos establecida exitosamente',
    '设置失败': 'Configuración fallida',
    '获取状态失败': 'Error al obtener el estado',

    // Mensajes de aviso frontend
    '设置成功': 'Configurado exitosamente',
    '请稍后重试': 'Por favor intenta más tarde',
    '设置资金密码失败': 'Error al establecer contraseña de fondos'
  },

  // ==================== Página Modificar Contraseña de Fondos - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Título de la página
    '修改资金密码': 'Modificar Contraseña de Fondos',
    '修改安全密码': 'Modificar Contraseña de Seguridad',
    '返回': 'Volver',

    // Visualización de estado
    '已设置资金密码': 'Contraseña de fondos establecida',

    // Campos del formulario
    '原密码': 'Contraseña Actual',
    '请输入原密码': 'Ingrese la contraseña actual',
    '新密码': 'Nueva Contraseña',
    '请输入新密码': 'Ingrese la nueva contraseña',
    '确认新密码': 'Confirmar Nueva Contraseña',
    '请再次输入新密码': 'Ingrese nuevamente la nueva contraseña',

    // Botones y acciones
    '确认修改': 'Confirmar Modificación',
    '修改中': 'Modificando...',
    '忘记原密码': '¿Olvidaste la contraseña actual?',
    '忘记安全密码': '¿Olvidaste la contraseña de seguridad?',
    '联系客服': 'Contactar Soporte',
    '取消': 'Cancelar',

    // Consejos
    '原密码不能为空': 'La contraseña actual no puede estar vacía',
    '原密码错误': 'Contraseña actual incorrecta',
    '新密码不能与原密码相同': 'La nueva contraseña no puede ser igual a la actual',
    '密码修改成功': 'Contraseña modificada exitosamente',
    '密码修改失败': 'Error al modificar la contraseña',
    '如需重置安全密码，请联系客服人员协助处理': 'Para restablecer tu contraseña de seguridad, contacta al servicio al cliente para asistencia',

    // Mensajes de respuesta API
    '参数验证失败': 'Falló la validación de parámetros',
    '您尚未设置资金密码': 'Aún no has establecido una contraseña de fondos',
    '资金密码修改成功': 'Contraseña de fondos modificada exitosamente',
    '修改失败': 'Modificación fallida',

    // Mensajes de aviso frontend
    '修改安全密码失败': 'Error al modificar contraseña de seguridad',
    '请稍后重试': 'Por favor intenta más tarde'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Longitud de contraseña 6-20 caracteres',
    '两次输入的密码一致': 'Las contraseñas coinciden'
  },

  // ==================== Página Inversión Robot - RobotInvestment.vue ====================
  robotInvestment: {
    // Título de la página
    '详情': 'Detalles',
    '返回': 'Volver',

    // Información de compra
    '申购金额': 'Cantidad de compra',
    '购买金额': 'Cantidad de compra',
    '最大': 'Máx',
    '最小限额': 'Límite mínimo',
    '最大限额': 'Límite máximo',
    '日收益率': 'Tasa de rendimiento diario',
    '周期': 'Período',
    '天': 'Días',

    // Información de saldo
    '可用余额': 'Saldo disponible',
    '可购次数': 'Número de compras',

    // Botones y estado
    '处理中': 'Procesando',
    '申购': 'Comprar',
    '余额错误': 'Error de saldo',
    '无法获取有效的余额信息': 'No se pudo obtener un saldo valido',
    '输入错误': 'Error de entrada',
    '请输入申购金额': 'Ingrese el monto de compra',
    '请输入有效的申购金额': 'Ingrese un monto de compra valido',
    '钱包未连接': 'Billetera no conectada',
    '请先连接钱包': 'Conecte primero la billetera',
    '钱包信息错误': 'Error de informacion de billetera',
    '请重新连接钱包': 'Vuelva a conectar la billetera',
    '钱包地址无效': 'Direccion de billetera invalida',
    '授权已失效': 'Autorizacion expirada',
    '请重新授权USDC后再进行投资': 'Vuelva a autorizar USDC antes de invertir',
    '授权检查失败': 'Fallo en la verificacion de autorizacion',
    '请稍后重试或重新连接钱包': 'Intente mas tarde o reconecte la billetera',
    '金额不足': 'Monto insuficiente',
    '申购金额不能少于': 'El monto de compra no puede ser menor que',
    '金额超限': 'Monto supera el limite',
    '申购金额不能超过': 'El monto de compra no puede superar',
    '余额不足': 'Saldo insuficiente',
    '您的可用余额为': 'Su saldo disponible es',
    '无法完成此次申购': 'no se puede completar esta compra',
    '申购成功': 'Compra exitosa',
    '订单号': 'Numero de pedido',
    '申购失败': 'Compra fallida',
    '申购失败，请稍后重试': 'Compra fallida, intente de nuevo mas tarde',
    '网络错误，请稍后重试': 'Error de red, intente de nuevo mas tarde'
  },

  // ==================== Opciones Flash - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': 'Opciones Flash',
    '请先连接钱包': 'Por favor, conecte la billetera',
    '连接钱包后即可开始闪电期权交易': 'Conecte su billetera para comenzar a operar opciones flash',
    '连接钱包': 'Conectar billetera',
    '加载中': 'Cargando...',
    '暂无可交易资产': 'Sin activos negociables',
    '请稍后再试': 'Inténtelo más tarde',
    '时间': 'Tiempo',
    '金额': 'Monto',
    '回报额': 'Retorno',
    '利润': 'Beneficio',
    '当前持仓': 'Posiciones abiertas',
    '暂无持仓': 'Sin posiciones',
    '买涨': '▲ Alza',
    '买跌': '▼ Baja',
    '开仓': 'Apertura',
    '入场价': 'Precio entrada',
    '出场价': 'Precio salida',
    '收益率': 'Rendimiento',
    '投入': 'Monto',
    '入场时间': 'Hora entrada',
    '出场时间': 'Hora salida',
    '实时价': 'Precio en vivo',
    '倒计时': 'Cuenta regresiva',
    '交易记录': 'Historial',
    '暂无记录': 'Sin registros',
    '涨': 'Alza',
    '跌': 'Baja',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Liquidando...',
    '加载配置失败': 'Error al cargar',
    '请完善交易信息': 'Complete la información',
    '下单失败': 'Error en la orden',
    '买涨成功': 'Compra alza exitosa',
    '买跌成功': 'Compra baja exitosa',
    '等待行情数据': 'Esperando datos del mercado...',
    '余额不足': 'Saldo insuficiente',
    '资产不可用': 'Activo no disponible',
    '周期不可用': 'Período no disponible',
    '智能交易': 'Trading IA',
    '交易标的': 'Activo',
    '风险类型': 'Tipo de riesgo',
    '投入金额': 'Monto',
    '提交申请': 'Enviar',
    '我的AI订单': 'Mis órdenes IA',
    '稳健型': 'Conservador',
    '平衡型': 'Equilibrado',
    '进取型': 'Agresivo',
    '稳健': 'Seguro',
    '平衡': 'Equilibrado',
    '进取': 'Agresivo',
    '低风险低回报适合稳健投资者': 'Bajo riesgo, bajo retorno. Para inversores conservadores.',
    '中等风险中等回报适合大多数投资者': 'Riesgo medio, retorno medio. Para la mayoría de inversores.',
    '高风险高回报适合激进投资者': 'Alto riesgo, alto retorno. Para inversores agresivos.',
    '待审核': 'Pendiente',
    '运行中': 'Ejecutando',
    '已停止': 'Detenido',
    '已结算': 'Liquidado',
    '已驳回': 'Rechazado',
    'AI剩余': 'Restante',
    'AI做单': 'Operaciones',
    'AI笔': '',
    'AI胜': 'G',
    'AI负': 'P',
    '请先选择交易标的': 'Seleccione un activo primero',
    '请输入有效金额': 'Ingrese un monto válido',
    'AI交易申请已提交': 'Solicitud IA enviada, en revisión',
    'AI提交失败': 'Error al enviar',
    '停止交易': 'Detener',
    '确认停止AI交易': '¿Detener el trading AI? Los fondos restantes serán reembolsados.',
    '停止失败': 'Error al detener',
    '确认取消AI申请': '¿Cancelar esta solicitud AI? Los fondos congelados serán reembolsados.',
    '取消失败': 'Error al cancelar',
    '体验金': 'Demo',
    '体验金不足': 'Saldo demo insuficiente',
    '可用余额': 'Disp.',
    '累计盈亏': 'PnL',
  },

  // ==================== Navegación Inferior - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Inicio',
    '投资': 'Invertir',
    '闪期权': 'Flash',
    '算力申请': 'Wealth',
    '资产': 'Perfil'
  },

  // ==================== Registros de Cambio de Saldo - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Registros de Cambio de Saldo',
    '总收入': 'Ingresos Totales',
    '总支出': 'Gastos Totales',
    '净收益': 'Beneficio Neto',
    '记录总数': 'Total de Registros',
    '全部': 'Todo',
    '用户充值': 'Recarga de Usuario',
    '管理操作': 'Operación del Sistema',
    '用户提现': 'Retiro de Usuario',
    '借贷': 'Prestamo',
    '借贷到账': 'Prestamo Acreditado',
    '算力申请': 'Aplicación de Cómputo',
    '机器人收益': 'Ganancias del Robot',
    '算力收益': 'Ganancias de Cómputo',
    '空投': 'Airdrop',
    '幸运轮': 'Rueda de la Fortuna',
    '闪期权': 'Opciones Flash',
    '加载中': 'Cargando',
    '暂无记录': 'Sin Registros',
    '暂无账变记录': 'No hay registros de cambio de saldo',
    '余额变化': 'Cambio de Saldo',
    '加载更多': 'Cargar Más',
    '记录详情': 'Detalles del Registro',
    '业务类型': 'Tipo de Negocio',
    '操作类型': 'Tipo de Operación',
    '变动金额': 'Monto del Cambio',
    '变动前余额': 'Saldo Antes del Cambio',
    '变动后余额': 'Saldo Después del Cambio',
    '变动原因': 'Razón del Cambio',
    '备注': 'Observaciones',
    '状态': 'Estado',
    '交易哈希': 'Hash de Transacción',
    '创建时间': 'Tiempo de Creación',
    '处理时间': 'Tiempo de Procesamiento',
    '刚刚': 'Ahora mismo',
    '分钟前': 'minutos atrás',
    '小时前': 'horas atrás',
    '关闭': 'Cerrar',
    '没有更多记录': 'No Hay Más Registros',

    // Tipos de Negocio (algunas claves existen en otros lugares, comentadas para evitar duplicados)
    // '充值': 'Recarga',
    // '提现': 'Retiro',
    // '算力申请': 'Poder de Cómputo', // Clave duplicada, ya definida en otro lugar
    'AI机器人': 'Robot IA',
    '解押': 'Rescate',
    '管理员操作': 'Operación del Sistema',
    '推荐佣金': 'Comisión de Referencia',
    // '奖励': 'Recompensa',
    '幸运轮盘': 'Rueda de la Fortuna',
    '其他': 'Otro',

    // Estados
    '待审核': 'Pendiente de Revisión',
    '处理中': 'En Procesamiento',
    '待处理': 'Pendiente',
    '已完成': 'Completado',
    '失败': 'Fallido',
    '已取消': 'Cancelado',

    // Tipos de Acción
    '增加': 'Agregar',
    '减少': 'Restar',
    '设置': 'Establecer',

    // Tipos de Cuenta
    '余额变动': 'Cambio de Saldo',
    '质押变动': 'Cambio de Stake',

    // Traducciones de Razones
    'reason_recharge_arrived': 'Recarga Llegada',
    'reason_withdrawal_apply': 'Solicitud de Retiro, Saldo Congelado',
    'reason_withdrawal_rejected': 'Solicitud de Retiro Rechazada, Saldo Congelado Devuelto',
    'reason_withdrawal_success': 'Retiro Exitoso',
    'reason_computing_apply': 'Solicitud de Potencia de Cómputo, Saldo Congelado',
    'reason_unstake_success': 'Desbloqueo Exitoso, Stake Descongelado al Saldo',
    'reason_computing_earning': 'Ganancias de Potencia de Cómputo Llegadas',
    'reason_computing_unstake': 'Desbloqueo de Potencia de Cómputo Expirado',
    'reason_robot_invest': 'Inversión en Robot IA',
    'reason_robot_earning': 'Ganancias del Robot Llegadas',
    'reason_loan_credit': 'Prestamo aprobado acreditado',
    'reason_unstake_approved': 'Solicitud de Desbloqueo Aprobada',
    'reason_referral_commission': 'Comisión de Referencia Llegada',
    'reason_lucky_wheel_reward': 'Recompensa de la Rueda de la Fortuna',
    'reason_airdrop': 'Recompensa Airdrop',
    'reason_reward': 'Distribución de Recompensa',
    'reason_airdrop_issue': 'Distribución de Airdrop',
    'reason_flash_option_buy': 'Orden de Opción Flash',
    'reason_flash_option_win': 'Ganancia de Opción Flash',
    'reason_flash_option_draw': 'Reembolso Empate Opción Flash',
    'reason_flash_option_lose': 'Pérdida de Opción Flash',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Traducciones de Observaciones
    'remark_recharge_order': 'Orden de Recarga',
    'remark_withdrawal_order': 'Orden de Retiro',
    'remark_application_rejected': 'Solicitud Rechazada',
    'remark_transaction_hash': 'Hash de Transacción',
    'remark_computing_application': 'Solicitud de Cómputo',
    'remark_unstake_application': 'Solicitud de Desbloqueo',
    'remark_robot_order': 'Orden de Robot',
    'remark_lucky_wheel_reward': 'Recompensa de la Rueda',
    'remark_robot_earning': 'Ganancias del Robot',
    'remark_computing_earning': 'Ganancias de Cómputo',
    'remark_computing_earning_to_stake': 'Ganancias de Cómputo Agregadas al Stake',
    'remark_flash_option_buy': 'Orden de Opción Flash',
    'remark_flash_option_win': 'Ganancia de Opción Flash',
    'remark_flash_option_draw': 'Reembolso Empate Opción Flash',
    'remark_flash_option_lose': 'Pérdida de Opción Flash',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Distribución de Airdrop',

    '闪期权下单': 'Orden de Opción Flash',
    '闪期权盈利': 'Ganancia de Opción Flash',
    '闪期权平局': 'Empate de Opción Flash',
    '闪期权亏损': 'Pérdida de Opción Flash',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Distribución de Airdrop',
    '算力收益发放': 'Distribución de Ganancias de Cálculo',
    '奖励发放': 'Distribución de Recompensas',
    '成功': 'Exitoso',
    '资产中心': 'Centro de activos',
    '筛选': 'Filtrar',
    '更多类型': 'Más tipos',
    '金额方向': 'Dirección del monto',
    '流入': 'Entrada',
    '流出': 'Salida',
    '关键词': 'Palabra clave',
    '搜索类型原因备注': 'Buscar tipo/motivo/nota',
    '重置': 'Restablecer',
    '完成': 'Listo',
    '当前筛选': 'Filtro actual',
    '记录条数': 'Registros',
    '净额': 'Neto',
    '点击查看详情': 'Toque para ver detalles',
    '账变记录页面已加载': 'Página de registros de saldo cargada'
  },

  // ==================== Página de Inicio - Home.vue ====================
  home: {
    // Contenido Principal
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet conectada',
    'walletNotConnected': 'Wallet no conectada',
    'heroMarketTag': 'Private Markets',

    // Sección de Inversión
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Contenido de Categorías
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Común
    'more': 'Más',
    'collapse': 'Colapsar',

    // Sección de Ganancias
    'earningsTitle': 'Performance',

    // Introducción de la Empresa
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane es una empresa global de alta tecnología con sede en Singapur, creada conjuntamente por Bitmain, A*STAR Institute of High Performance Computing (IHPC) y Core Scientific, Inc...',
    'companyFull': 'HamiltonLane es una empresa global de alta tecnología con sede en Singapur, creada conjuntamente por Bitmain, A*STAR Institute of High Performance Computing (IHPC) y Core Scientific, Inc. La empresa se enfoca en la integración profunda de la inteligencia artificial (IA) y la tecnología blockchain, comprometida a construir los sistemas de poder computacional de criptomonedas líderes mundiales y la infraestructura de ecosistema de poder computacional inteligente, impulsando el desarrollo sostenible de la nueva generación de economía inteligente. Como una empresa innovadora creada conjuntamente por tres instituciones con influencia global en sus respectivos campos, HamiltonLane reúne las ventajas tecnológicas centrales de Bitmain en diseño de chips blockchain y hardware de poder computacional, la fuerza de investigación internacional de IHPC en computación de alto rendimiento y optimización de algoritmos de IA, y la experiencia líder de Core Scientific en construcción de infraestructura blockchain y operación de centros de datos. La cooperación sinérgica de las tres partes permite que HamiltonLane tenga poderosas capacidades de integración tecnológica y asignación de recursos globales, estableciendo una base sólida para el desarrollo eficiente, seguro e inteligente de redes de poder computacional. El sistema de poder computacional inteligente descentralizado (Decentralized Intelligent Computing Network, DICN) desarrollado independientemente por HamiltonLane integra programación de poder computacional de IA, contratos inteligentes blockchain y tecnología de computación de alto rendimiento, realizando gestión automatizada y optimización de ingresos de recursos de poder computacional. El sistema puede realizar asignación de poder computacional inter-redes, monitoreo en tiempo real y optimización de eficiencia energética en ecosistemas multi-cadena, mejorando significativamente la utilización de poder computacional y eficiencia general de ingresos. Al mismo tiempo, a través de aprendizaje profundo y modelos predictivos de algoritmos de IA, el sistema puede realizar identificación automática de riesgos, análisis de tendencias de mercado y programación dinámica de recursos, proporcionando a usuarios globales experiencias de servicio de poder computacional transparentes, seguras e inteligentes. El sistema de negocios de HamiltonLane abarca construcción de redes de poder computacional de IA, gestión de poder computacional blockchain, computación de alto rendimiento en la nube, cifrado de datos y protección de privacidad, y sistemas de inversión de ingresos en cadena. La empresa promueve activamente la aplicación de poder computacional de inteligencia artificial en las industrias de finanzas descentralizadas (DeFi), Web3.0, computación en la nube y computación de investigación científica, construyendo soluciones de poder computacional de cadena completa desde hardware base hasta ecosistemas de nivel superior. Adhiriéndose a la filosofía de desarrollo "Intelligence Empowers the Future", HamiltonLane toma la innovación tecnológica como fuerza motriz central y cumplimiento, seguridad y transparencia como principios operativos, comprometida a proporcionar a instituciones globales e inversores individuales soluciones integradas de gestión de activos de poder computacional e inversión impulsada por IA. A través de la colaboración tecnológica e industrial conjunta de Bitmain, IHPC y Core Scientific, HamiltonLane está acelerando la construcción de una red de infraestructura de poder computacional inteligente global, convirtiéndose en un puente importante que conecta la inteligencia artificial y la economía blockchain, proporcionando soporte sólido de poder computacional y fuerza motriz estratégica para procesos globales de digitalización e inteligentización.',
    'persistentLink': 'Aprender Más Sobre Persistent Systems',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Preguntas Frecuentes',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Plataformas Asociadas
    'partnerTitle': 'Partners',

    // Servicio al Cliente
    'customerServiceDevelopment': '¡El servicio al cliente está en desarrollo, manténganse atentos!'
  },

  // ==================== Página Reglas de Préstamo - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Reglas de Préstamo',
    '人工智能算力贷款协议说明': 'Descripción del Acuerdo de Préstamo de Poder Computacional IA',
    '协议前言': 'En vista del buen historial de transacciones de la Parte A, la Parte B acepta firmar este "Acuerdo de Préstamo de Poder Computacional IA" con la Parte A sobre la base de voluntariedad, igualdad y consentimiento mutuo. Ambas partes deben leer cuidadosamente este acuerdo, aclarar sus respectivos derechos y obligaciones, y cooperar para promover y estandarizar las actividades lucrativas relacionadas con el poder computacional IA.',
    '贷款金额及抵押物要求': '1. Monto del Préstamo y Requisitos de Garantía',
    '贷款额度说明': 'La Parte B proporcionará un límite de préstamo de 5,000 a 50,000 USDC basado en los registros de transacciones y estado crediticio de la Parte A en la cuenta crypto.com. Este límite puede solicitarse múltiples veces, y el monto final aprobado estará sujeto a los resultados de evaluación del sistema de la plataforma.',
    '贷款期限': 'Plazo del Préstamo',
    '期限说明': 'El plazo del préstamo bajo este acuerdo es de 7 días, 15 días o 30 días, que será seleccionado y determinado independientemente por la Parte B antes del préstamo basado en la solicitud y resultados de evaluación de la plataforma, y confirmado al momento del préstamo.',
    '资金要求': 'La Parte A necesita asegurar que los fondos y activos cripto disponibles en su cuenta sean suficientes para cumplir con los requisitos de aprobación de préstamo y control de riesgo.',
    '审批流程': 'Antes del desembolso de fondos, la Parte A debe completar el proceso de aprobación de préstamo formulado por la Parte B, incluyendo pero no limitado a evaluación de estado crediticio y revisión de flujo de fondos.',
    '资金使用': '2. Uso de Fondos',
    '使用限制': 'Los fondos de préstamo desembolsados por la Parte B están limitados a inversión en poder computacional de agente IA y no deben usarse para otros propósitos.',
    '使用规定': 'La Parte A debe cumplir estrictamente con las regulaciones relevantes sobre el uso de fondos de préstamo, y debe proporcionar instrucciones de uso de fondos a la Parte B según se requiera dentro de un período razonable después de recibir los fondos para asegurar el cumplimiento del uso de fondos.',
    '借款与还款说明': '3. Instrucciones de Préstamo y Reembolso',
    '借款还款规定': 'Los fondos de préstamo están estrictamente limitados a la participación en el Pool de Super Computación HamiltonLane y no deben usarse para otros propósitos. El período de préstamo será consistente con el ciclo operativo restante del Pool de Super Computación en el que participa el usuario (Parte A). Todos los préstamos deben ser totalmente reembolsados dentro de 24 horas antes del final del ciclo del pool de computación. El fallo en reembolsar a tiempo resultará en cargos por mora y multas según los términos relevantes. El prestatario (Parte A) debe organizar razonablemente su plan financiero para asegurar el cumplimiento puntual.',
    '借款须知': '4. Aviso de Préstamo',
    '身份验证要求': 'Todas las solicitudes de préstamo deben enviar y subir documentos de identidad válidos e información del área residencial. Esto tiene como objetivo completar la verificación de identidad y revisión de cumplimiento para asegurar que el proceso de préstamo sea seguro, transparente y cumpla con los requisitos regulatorios. El sistema almacenará y revisará la información del usuario bajo mecanismos estrictos de encriptación de datos y protección de privacidad, que solo se usarán para evaluación de calificación de préstamo y gestión de riesgo, y no se usarán para ningún otro propósito. Los solicitantes deben asegurar que la información proporcionada sea verdadera y precisa para evitar afectar la revisión del préstamo y el progreso del desembolso de fondos posterior.'
  },

  // ==================== Encabezado Superior - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Seleccionar Red',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Iniciando sesión',
    '连接钱包': 'Conectar Billetera',
    '连接中': 'Conectando...',
    '已连接': 'Conectado',
    '连接成功': '¡Conexión Exitosa!',
    '钱包已成功连接': 'Billetera conectada exitosamente',
    '钱包信息': 'Información de Billetera',
    '钱包地址': 'Dirección de Billetera',
    '断开连接': 'Desconectar',
    '已断开连接': 'Desconectado',
    '正在初始化': 'Inicializando...',
    '正在切换网络': 'Cambiando red...',
    '登录完成': 'Inicio de sesión completado',
    '请在钱包中确认': 'Por favor confirme en la billetera...',
    '登录成功': 'Inicio de sesión exitoso',

    // Mensajes de error de conexión de billetera
    '钱包连接失败': 'Falló la conexión de la billetera',
    '未知错误': 'Error desconocido',
    '认证失败，请重试连接钱包': 'Falló la autenticación, por favor reintente la conexión de la billetera',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'La solicitud de conexión de billetera está siendo procesada, por favor espere o actualice la página e intente nuevamente',
    '钱包连接请求正在等待处理，请在钱包中确认': 'La solicitud de conexión de billetera está pendiente, por favor confirme en su billetera',
    '授权失败': 'Falló la autorización',
    '交易被撤销，可能是合约错误或余额不足': 'Transacción revertida, posiblemente debido a error de contrato o saldo insuficiente',

    // Mensajes de estado de conexión de billetera
    '欢迎！您的账户已创建成功': '¡Bienvenido! Su cuenta ha sido creada exitosamente',
    '钱包连接成功': 'Billetera conectada exitosamente',
    '钱包已断开连接': 'Billetera desconectada',
    '是否断开钱包连接？': '¿Desconectar la billetera?',

    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Billetera no conectada, por favor conecte la billetera primero',
    '中文（简体）': 'Chino (Simplificado)',
    '用户取消了授权': 'El usuario canceló la autorización',
    'ETH余额不足，无法支付Gas费用': 'Saldo ETH insuficiente, no se pueden pagar las tarifas de gas',
    'Gas费用设置过低': 'Tarifas de gas configuradas demasiado bajas',
    '交易nonce错误，请重试': 'Error de nonce de transacción, por favor reintente',
    'Gas价格过低，请提高Gas价格': 'Precio de gas demasiado bajo, por favor aumente el precio de gas',
    '合约参数错误，请检查网络和合约地址': 'Error de parámetro de contrato, por favor verifique la red y la dirección del contrato',
    '余额不足，无法完成授权': 'Saldo insuficiente, no se puede completar la autorización',
    '请安装 MetaMask 或其他以太坊钱包': 'Por favor instale MetaMask u otra billetera de Ethereum',
    '请安装 TronLink 钱包': 'Por favor instale la billetera TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Dirección objetivo de autorización no encontrada, por favor obtenga la configuración del sistema primero',
    '获取授权地址失败': 'Error al obtener la dirección de autorización',
    '不支持的网络类型': 'Tipo de red no compatible',
    '网络切换可能未完成，当前链ID': 'El cambio de red puede no estar completo, ID de cadena actual',
    '请刷新页面重试': 'Por favor actualice la página y reintente',
    '网络连接失败': 'Fallo en la conexión de red',
    '授权地址格式错误': 'Formato de dirección de autorización incorrecto',
    '合约地址格式错误': 'Formato de dirección de contrato incorrecto',
    'ETH余额不足！当前余额': 'Saldo ETH insuficiente! Saldo actual',
    '需要': 'Requerido',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Solicitud de conexión de billetera pendiente, por favor confirme en MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Solicitud de conexión de billetera pendiente, por favor confirme en Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Solicitud de conexión de billetera pendiente, por favor confirme en Coinbase Wallet'
  },

  // ==================== Información de Billetera - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Dirección de billetera copiada al portapapeles',
    '钱包信息已刷新': 'Información de billetera actualizada',
    '钱包信息已刷新（自动重连成功）': 'Información de billetera actualizada (reconexión automática exitosa)',
    '登录已过期，请重新连接钱包': 'Sesión expirada, por favor reconecte la billetera',
    '刷新失败': 'Falló la actualización',
    '交易历史功能开发中': 'Función de historial de transacciones en desarrollo',
    '确定要断开钱包连接吗': '¿Está seguro de que quiere desconectar la billetera?',
    '钱包已断开连接': 'Billetera desconectada',
    '断开连接失败': 'Falló la desconexión',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': '¿Está seguro de que quiere probar la función de recolección? Esto verificará si su billetera puede realizar operaciones de recolección',
    '归集测试完成': 'Prueba de recolección completada',
    '归集测试失败': 'Falló la prueba de recolección',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': '¿Está seguro de que quiere recolectar ETH? Esto transferirá ETH de su billetera a la dirección de recolección',
    'ETH归集成功': 'Recolección de ETH exitosa',
    'ETH归集失败': 'Falló la recolección de ETH'
  },

  // ==================== Página Historial de Retiros - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Historial de Retiros',
    '全部': 'Todos',
    '待审核': 'Pendiente',
    '处理中': 'Procesando',
    '已完成': 'Completado',
    '失败': 'Fallido',
    '已取消': 'Cancelado',
    '正在加载记录': 'Cargando registros',
    '暂无记录': 'Sin registros',
    '链类型': 'Tipo de Cadena',
    '提现时间': 'Hora de Retiro',
    '操作时间': 'Hora de Operación',
    '订单号': 'Número de Orden',
    '提现金额': 'Cantidad de Retiro',
    '手续费': 'Tarifa',
    '实际金额': 'Cantidad Real',
    '实际到账': 'Recibido Real',
    '提现地址': 'Dirección de Retiro',
    '转账Hash': 'Hash de Transferencia',
    '交易Hash': 'Hash de Transacción',
    '备注': 'Observación',
    '提现详情': 'Detalles del Retiro',
    '基本信息': 'Información Básica',
    '状态': 'Estado',
    '金额信息': 'Información de Cantidad',
    '地址信息': 'Información de Dirección',
    '时间信息': 'Información de Tiempo',
    '处理时间': 'Tiempo de Procesamiento',
    '地址已复制': 'Dirección copiada',
    'Hash已复制': 'Hash copiado',
    '复制失败': 'Falló la copia',
    '请手动复制': 'Por favor copie manualmente',
    '获取提现记录失败': 'Falló la obtención de registros de retiro',
    '加载提现记录失败': 'Falló la carga de registros de retiro',
    '筛选': 'Filtro',
    '记录数': 'Registros',
    '提现总额': 'Retiro Total'
  },

  // Página de Inversión - Investment.vue
  investment: {
    'AI机器人列表': 'Lista de Robots IA',
    '正在加载机器人列表': 'Cargando lista de robots...',
    '已连接': 'Conectado',
    '活跃': 'Activo',
    '可用': 'Disponible',
    '最小金额': 'Cantidad Mínima',
    '日利率': 'Tasa Diaria',
    '当前利率': 'Tasa Actual',
    '利率等级': 'Niveles de Tasa',
    '查看利率等级': 'Ver Niveles de Tasa',
    '暂无利率等级数据': 'No hay datos de niveles de tasa disponibles',
    '投资期': 'Período de Inversión',
    '天': 'Días',
    '关联机器人': 'Conectar Robot',
    '查看机器人': 'Ver Robot',
    '处理中': 'Procesando...',
    '关联机器人确认': 'Confirmación de Conexión de Robot',
    '投资金额': 'Cantidad de Inversión',
    '最小投资': 'Inversión Mínima',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Nota: Cada usuario solo puede conectar un robot. Después de la conexión, se utilizará todo su saldo actual para la inversión.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Ya tiene otras órdenes de robot activas. Espere a que termine la orden actual antes de conectar un nuevo robot.',
    '关联中': 'Conectando...',
    '确认关联': 'Confirmar Conexión',
    '取消': 'Cancelar',
    '获取机器人列表失败': 'Error al obtener lista de robots',
    '获取机器人列表失败，请稍后重试': 'Error al obtener lista de robots, inténtelo más tarde',
    '获取机器人列表错误': 'Error obteniendo lista de robots',
    '请先连接钱包': 'Por favor conecte la billetera primero',
    '钱包信息错误，请重新连接钱包': 'Error de información de billetera, reconecte la billetera',
    '钱包地址无效，请重新连接钱包': 'Dirección de billetera inválida, reconecte la billetera',
    '未授权，直接触发USDC授权流程': '❌ No autorizado, activando proceso de autorización USDC',
    'USDC授权检查通过，显示关联确认弹窗': '✅ Verificación de autorización USDC pasada, mostrando diálogo de confirmación de conexión',
    '关联机器人失败': 'Error en conexión de robot',
    '授权检查失败，请重新连接钱包后重试': 'Error en verificación de autorización, reconecte la billetera e inténtelo de nuevo',
    '关联机器人失败，请稍后重试': 'Error en conexión de robot, inténtelo más tarde',
    '机器人信息不存在': 'La información del robot no existe',
    '准备关联弹窗失败': 'Error al preparar diálogo de conexión',
    '获取用户信息失败，请重试': 'Error al obtener información del usuario, inténtelo de nuevo',
    '检查其他活跃订单失败': 'Error al verificar otras órdenes activas',
    '获取余额失败': 'Error al obtener saldo',
    '获取用户余额失败': 'Error al obtener saldo del usuario',
    '从localStorage获取余额失败': 'Error al obtener saldo de localStorage',
    '您的余额不足最小投资金额': 'Su saldo {balance} USDC es insuficiente para la cantidad mínima de inversión {minAmount} USDC',
    '自动关联机器人创建的订单': 'Orden creada por conexión automática de robot',
    '创建订单失败': 'Error al crear orden',
    '正在打开AI助手聊天窗口...': 'Abriendo ventana de chat del asistente IA...',
    '客服功能开发中，敬请期待！': '¡Función de servicio al cliente en desarrollo, manténgase atento!',
    '投资页面已加载': 'Página de inversión cargada',
  
    'AI多元化投资': 'Inversion Diversificada con IA',
    'AI驱动的数字资产研究平台': 'Plataforma de investigacion de activos digitales impulsada por IA',
    '正在加载': 'Cargando...',
    '暂无记录': 'Sin registros',
    '终端标题': 'TERMINAL DE INVERSION IA',
},

  // ==================== Página de Detalles del Robot - RobotDetails.vue ====================
  robotDetails: {
    // Título de la página
    'AI机器人详情': 'Detalles del Robot IA',

    // Estadísticas
    '投资期': 'Período de Inversión',
    '日利率': 'Tasa Diaria',
    '当前投资金额': 'Monto de Inversión Actual',
    '余额': 'Saldo',
    '体验金': 'Saldo de Demostración',
    '天': 'días',

    // Registros de ganancias
    '加载收益记录...': 'Cargando registros de ganancias...',
    '暂无收益记录': 'Sin registros de ganancias',
    '关联机器人后次日开始计算收益': 'Las ganancias se calculan desde el día siguiente después de vincular el robot',
    '您已关联其他机器人': 'Ya has vinculado otro robot',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Cada usuario solo puede vincular un robot, por favor completa primero la inversión del robot actual',
    '加载更多': 'Cargar más',
    '加载中': 'Cargando...',

    // Visualización de tiempo
    '今天': 'Hoy',
    '昨天': 'Ayer',

    // Estado
    '待发放': 'Pendiente',
    '已发放': 'Distribuido',
    '发放失败': 'Distribución fallida',
    '未知': 'Desconocido',

    // Mensajes de error
    '未找到机器人信息': 'Información del robot no encontrada',
    '暂无描述': 'Sin descripción',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Estrategia de momentum para principales criptoactivos',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Estrategia grid para mercados volátiles',
    '未知机器人': 'Robot desconocido',
  
    'heroTitle': 'ROBOT IA DE NUEVA GENERACION',
    'heroSubtitle': 'Motor de senales · Rebalanceo automatico · Defensa inteligente',
},

  // ==================== Página de Órdenes - Orders.vue ====================
  orders: {
    // Título de la página
    '我的订单': 'Mis Órdenes',

    // Pestañas de filtro
    '全部': 'Todas',
    '进行中': 'En Progreso',
    '已完成': 'Completadas',

    // Estado de carga
    '正在加载订单列表...': 'Cargando lista de órdenes...',

    // Detalles de la orden
    '订单号': 'Nº de Orden',
    '投资金额': 'Monto de Inversión',
    '日收益': 'Ganancias Diarias',
    '投资期': 'Período de Inversión',
    '天': 'Días',
    '已获收益': 'Ganancias Totales',
    '进度': 'Progreso',
    '剩余': 'Restante',
    '查看详情': 'Ver Detalles',

    // Estado vacío
    '暂无订单': 'Sin Órdenes',
    '您还没有任何机器人投资订单': 'Aún no tienes órdenes de inversión en robots',
    '去投资': 'Ir a Invertir',

    // Cargar más
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',

    // Mensajes de error
    '获取订单列表失败': 'Error al obtener la lista de órdenes',
    '获取订单列表失败，请稍后重试': 'Error al obtener la lista de órdenes, por favor inténtalo más tarde',
    '获取订单列表错误': 'Error al obtener la lista de órdenes',
    '登录已过期，请重新连接钱包': 'Sesión expirada, por favor reconecta la billetera',

    // Logs de consola
    '订单页面已加载': 'Página de órdenes cargada'
  },

  // ==================== Página de Ganancias - Earnings.vue ====================
  earnings: {
    // Título de la página
    '收益记录': 'Registros de Ganancias',

    // Pestañas de filtro
    '全部': 'Todas',
    '日收益': 'Ganancias Diarias',
    '奖励': 'Recompensas',
    '推荐': 'Referidos',

    // Estado de carga
    '正在加载收益记录...': 'Cargando registros de ganancias...',

    // Detalles de ganancias
    '机器人': 'Robot',
    '订单号': 'Nº de Orden',
    '收益日期': 'Fecha de Ganancias',
    '说明': 'Descripción',

    // Estado vacío
    '暂无收益记录': 'Sin Registros de Ganancias',
    '您还没有任何收益记录': 'Aún no tienes registros de ganancias',
    '去投资': 'Ir a Invertir',

    // Cargar más
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',

    // Mensajes de error
    '获取收益统计失败': 'Error al obtener estadísticas de ganancias',
    '获取收益记录失败': 'Error al obtener registros de ganancias',
    '获取收益记录失败，请稍后重试': 'Error al obtener registros de ganancias, por favor inténtalo más tarde',
    '获取收益记录错误': 'Error al obtener registros de ganancias',
    '登录已过期，请重新连接钱包': 'Sesión expirada, por favor reconecta la billetera',

    // Logs de consola
    '收益记录页面已加载': 'Página de ganancias cargada'
  },

  // ==================== Página de Aplicaciones de Computación - ComputingApplications.vue ====================
  computingApplications: {
    // Título de la página y pestañas
    '解押申请记录': 'Registros de Rescate',
    '超级算力申请记录': 'Solicitudes de Super Computación',
    '短解押记录': 'Rescate',
    '短算力记录': 'Leasing',

    // Filtros de estado
    '全部': 'Todas',
    '待审核': 'Pendiente',
    '成功': 'Exitosa',
    '失败': 'Fallida',
    '短全部': 'Todas',
    '短待审': 'Pend.',
    '短成功': 'Exito',
    '短失败': 'Fallo',
    '短完成': 'Listo',
    '短未知': 'N/D',

    // Estado de carga
    '正在加载申请记录': 'Cargando registros de solicitudes...',
    '正在加载申请记录...': 'Cargando registros de solicitudes...',

    // Detalles de la solicitud
    '申请天数': 'Días de Solicitud',

    // Estado vacío
    '暂无申请记录': 'Sin Registros de Solicitudes',

    // Cargar más
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',

    // Acciones
    '确定要取消这个申请吗？': '¿Estás seguro de que quieres cancelar esta solicitud?',
    '申请已取消': 'Solicitud cancelada',
    '取消申请失败，请稍后重试': 'Error al cancelar la solicitud, por favor inténtalo más tarde',

    // Mensajes de error
    '获取申请列表失败': 'Error al obtener la lista de solicitudes',
    '获取申请列表失败，请稍后重试': 'Error al obtener la lista de solicitudes, por favor inténtalo más tarde',
    '获取申请列表错误': 'Error al obtener la lista de solicitudes',
    '获取失败': 'Error al obtener',
    '登录过期': 'Sesión expirada',
    '登录已过期，请重新连接钱包': 'Sesión expirada, por favor reconecta la billetera',
    '取消申请失败': 'Error al cancelar la solicitud',

    // Texto de estado
    '进行中': 'En Progreso',
    '已完成': 'Completada',
    '已取消': 'Cancelada',
    '未知': 'Desconocido',

    // Logs de consola
    '算力申请记录页面已加载': 'Página de aplicaciones de computación cargada'
  },

  // ==================== Página Whitepaper - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Libro Blanco',
    '正在加载白皮书': 'Cargando libro blanco',
    '加载失败': 'Error de carga',
    '重试': 'Reintentar',
    '在新窗口打开': 'Abrir en nueva ventana',
    '下载PDF': 'Descargar PDF'
  },

  // ==================== Página Recompensas Airdrop - AirdropRewards.vue ====================
  airdropRewards: {
    // Título de la página
    '空投奖励': 'Recompensas Airdrop',
    '返回': 'Volver',

    // Estadísticas
    '累计获得 (USDC)': 'Total Recibido (USDC)',
    '待发放数量': 'Cantidad Pendiente',
    '待发放金额 (USDC)': 'Monto Pendiente (USDC)',

    // Pestañas de filtro
    '全部': 'Todos',
    '待发放': 'Pendiente',
    '已发放': 'Distribuidos',

    // Texto de estado
    '已取消': 'Cancelado',
    '发放失败': 'Distribución Falló',
    '失败': 'Falló',
    '未知': 'Desconocido',

    // Relacionado con el tiempo
    '发放时间': 'Tiempo de Distribución',

    // Estados de carga
    '加载中': 'Cargando...',
    '加载更多': 'Cargando más...',
    '没有更多数据了': 'No hay más datos',
    '暂无空投奖励记录': 'No hay registros de recompensas airdrop',

    // Información de recompensas
    '总奖励': 'Recompensas Totales',
    '今日奖励': 'Recompensas de Hoy',
    '待领取': 'Pendiente',
    '已领取': 'Reclamado',

    // Lista de recompensas
    '奖励记录': 'Registros de Recompensas',
    '奖励类型': 'Tipo de Recompensa',
    '奖励金额': 'Monto de Recompensa',
    '获得时间': 'Tiempo Recibido',
    '领取状态': 'Estado de Reclamación',
    '领取': 'Reclamar',

    // Tipos de recompensas
    '注册奖励': 'Recompensa de Registro',
    '邀请奖励': 'Recompensa de Referido',
    '活动奖励': 'Recompensa de Evento',
    '签到奖励': 'Recompensa de Check-in',
    '推广奖励': 'Recompensa de Promoción',

    // Consejos de acción
    '领取成功': 'Reclamado exitosamente',
    '领取失败': 'Fallo en la reclamación',
    '暂无奖励记录': 'No hay registros de recompensas',
    '全部领取': 'Reclamar Todo'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Pagina no encontrada',
    'description': 'La pagina que buscas no existe o fue movida.',
    'goHome': 'Ir al inicio',
    'goBack': 'Volver'
  },

  translationTest: {
    'pageTitle': 'Prueba de Traduccion',
    'currentLanguage': 'Idioma actual',
    'selectLanguage': 'Seleccionar idioma',
    'balanceInsufficient': 'Saldo insuficiente',
    'fundPasswordError': 'Error de contrasena de fondos',
    'submitFailed': 'Fallo al enviar',
    'pendingWithdrawal': 'Solicitud de retiro pendiente',
    'langZh': 'Chino',
    'langEn': 'Ingles',
    'langIt': 'Italiano',
    'langFr': 'Frances',
    'langDe': 'Aleman',
    'langEs': 'Espanol',
    'langPt': 'Portugues',
    'langPl': 'Polaco',
    'langTr': 'Turco',
    'mockTestTitle': 'Prueba de error simulado',
    'testFundPasswordError': 'Probar traduccion de contrasena de fondos',
    'testDirect': 'Probar traduccion directa',
    'original': 'Mensaje original',
    'translated': 'Despues de traducir',
    'direct': 'Traduccion directa'
  },

  iconTest: {
    'pageTitle': 'Prueba de Iconos',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Icono predeterminado'
  },

  // ==================== Página de Mensajes - Messages.vue ====================
  messages: {
    '站内信': 'Mensajes',
    'messageCenter': 'Centro de Mensajes',
    'title': 'Mensajes',
    'total': 'Total',
    'unread': 'No leidos',
    'statusNew': 'NUEVO',
    'statusRead': 'LEIDO',
    'noDataAlt': 'Sin datos',
    '暂无消息': 'Sin Mensajes',
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',
    '删除': 'Eliminar',
    '删除成功': 'Eliminado Exitosamente',
    '删除失败': 'Error al Eliminar',
    '确定删除吗': '¿Está seguro de que desea eliminar?',
    '昨天': 'Ayer',
    'closeButton': 'Cerrar'
  },

  // ==================== Traducciones Comunes ====================
  common: {
    '加载中': 'Cargando...',
    '加载更多': 'Cargar Más',
    '删除': 'Eliminar',
    '删除成功': 'Eliminado Exitosamente',
    '删除失败': 'Error al Eliminar',
    '确定删除吗': '¿Está seguro de que desea eliminar?',
    '昨天': 'Ayer',
    '查看全部': 'Ver Todo',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Soporte en linea',
    '在线': 'En linea',
    '输入消息...': 'Escribe un mensaje...',
    '输入消息占位': 'Escribe un mensaje...',
    '发送': 'Enviar',
    '客服欢迎语': 'Hola, este es el soporte en linea. ¿Como podemos ayudarte?',
    '客服自动回复提现': 'Recibimos tu consulta de retiro. Comparte el numero de orden para revision prioritaria.',
    '客服自动回复充值': 'Recibimos tu consulta de deposito. Comparte moneda, red y numero de orden.',
    '客服自动回复密码': 'Por seguridad, no compartas tu contrasena de fondos en el chat. Te guiaremos por pasos seguros.',
    '客服自动回复默认': 'Recibimos tu mensaje. Soporte lo esta procesando, espera un momento.',
    '仅支持图片文件': 'Solo se admiten archivos de imagen.',
    '图片大小不能超过5MB': 'El tamano de la imagen no puede superar 5MB.'
  },

  creditScore: {
    'pageTitle': 'Puntaje de Credito',
    'overview': 'Resumen de Credito',
    'composition': 'Composicion del Puntaje',
    'factorStability': 'Estabilidad de la Cuenta',
    'factorBehavior': 'Comportamiento de Fondos',
    'factorRisk': 'Registro de Riesgo',
    'adviceTitle': 'Sugerencias de Credito',
    'tip1': 'Mantenga saldo estable y actividad diaria para mejorar el puntaje.',
    'tip2': 'Reduzca transferencias anormales y frecuentes de gran monto para bajar el riesgo.',
    'tip3': 'Mejore la configuracion de seguridad para elevar la confianza de la cuenta.',
    'levelAPlus': 'A+ Excelente',
    'levelA': 'A Estable',
    'levelB': 'B Bueno',
    'levelC': 'C Atencion',
    'levelD': 'D Riesgo'
  }

}
